import "./ProyectosCommon.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { TecnicoResponse, TecnicoStatsResponse } from "../../../shared/response/proyectos/TecnicoResponse";
import { TecnicoService } from "../../services/proyectos/TecnicoService";
import { TecnicoDeleteService } from "../../services/proyectos/TecnicoDeleteService";
import { TecnicoFormModal } from "./TecnicoFormModal";
import { ConfirmDialogComponent } from "../../../shared/components/ConfirmDialogComponent";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";
import { formatKg } from "../../../shared/utils/formatUtils";

export class TecnicosPage extends BasePageComponent {
  private _all: TecnicoResponse[] = [];
  private _filtered: TecnicoResponse[] = [];
  private _tbody!:  HTMLTableSectionElement;
  private _totEl!:  HTMLSpanElement;
  private _search!: HTMLInputElement;

  public getAppRoute(): string { return "/proyectos/tecnicos"; }
  public getPageTitle(): string | null { return "Proyectos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page pr-page";
    pageContent.innerHTML = `
      <div class="pr-content">
        <div class="pr-pg-hd">
          <div>
            <div class="pr-pg-ey">Proyectos · Configuración</div>
            <div class="pr-pg-ti">Técnicos</div>
            <div class="pr-pg-su">Técnicos que crean y gestionan proyectos</div>
          </div>
          <button class="sx-btn sx-btn-primary sx-btn-sm" id="tec-nuevo"><i class="ph ph-plus"></i> Nuevo técnico</button>
        </div>

        <div class="pr-kstrip" id="tec-kstrip"></div>

        <div class="pr-frow">
          <div class="pr-sw">
            <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
            <input class="pr-si" id="tec-search" placeholder="Buscar nombre, correo o zona…">
          </div>
          <span class="pr-ftot" id="tec-tot"></span>
        </div>

        <div class="pr-tbl-wrap">
          <table class="pr-tbl">
            <thead>
              <tr><th>Técnico</th><th>Zona</th><th>Teléfono</th><th>Proyectos</th><th>Ha total</th><th>Estado</th><th>Acciones</th></tr>
            </thead>
            <tbody id="tec-tbody"><tr><td colspan="7" class="pr-empty">Cargando…</td></tr></tbody>
          </table>
        </div>
      </div>
    `;

    this._tbody  = document.getElementById("tec-tbody")! as HTMLTableSectionElement;
    this._totEl  = document.getElementById("tec-tot")!;
    this._search = document.getElementById("tec-search")! as HTMLInputElement;
    this._search.oninput = () => this._filterAndRender();
    document.getElementById("tec-nuevo")!.onclick = () => this._onCreate();

    void this._loadData();
  }

  protected override beforeDispose(): void {}

  private async _loadData(): Promise<void> {
    try {
      const [items] = await Promise.all([TecnicoService.instance.get(), this._loadStats()]);
      this._all = items.filter((t) => !t.isEliminado).sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._filterAndRender();
    } catch (error) {
      errorMessageComponent.addError("Error al cargar técnicos", (error as Error).message);
      this._tbody.innerHTML = `<tr><td colspan="7" class="pr-empty">Error al cargar</td></tr>`;
    }
  }

  private async _loadStats(): Promise<void> {
    try {
      const s: TecnicoStatsResponse = await TecnicoService.instance.getStats();
      document.getElementById("tec-kstrip")!.innerHTML = `
        ${this._kpi(String(s.totalTecnicos), "TÉCNICOS", "")}
        ${this._kpi(String(s.activos), "ACTIVOS", "green")}
        ${this._kpi(String(s.totalProyectos), "PROYECTOS", "blue")}
        ${this._kpi(formatKg(s.totalHa) + " ha", "HA TOTAL", "")}
      `;
    } catch { /* KPIs opcionales */ }
  }

  private _kpi(value: string, label: string, color: string): string {
    return `<div class="pr-kcard"><div class="pr-k-val ${color}">${value}</div><div class="pr-k-lbl">${label}</div></div>`;
  }

  private _filterAndRender(): void {
    const q = this._search.value.toLowerCase().trim();
    this._filtered = this._all.filter((t) =>
      !q || t.nombre.toLowerCase().includes(q) || t.email.toLowerCase().includes(q) || (t.zona || "").toLowerCase().includes(q),
    );
    this._render();
  }

  private _render(): void {
    const list = this._filtered;
    this._totEl.textContent = `${list.length} técnico${list.length === 1 ? "" : "s"}`;
    if (list.length === 0) {
      this._tbody.innerHTML = `<tr><td colspan="7" class="pr-empty">Sin resultados</td></tr>`;
      return;
    }
    this._tbody.innerHTML = list.map((t, i) => `
      <tr>
        <td><div style="font-weight:var(--sx-weight-semibold)">${this._esc(t.nombre)}</div><div style="font-size:var(--sx-text-xs);color:var(--sx-text-tertiary)">${this._esc(t.email)}</div></td>
        <td>${this._esc(t.zona || "—")}</td>
        <td>${this._esc(t.telefono || "—")}</td>
        <td class="pr-num">${t.totalProyectos}</td>
        <td class="pr-num">${formatKg(t.totalHa)} ha</td>
        <td>
          ${t.isActivo ? `<span class="pr-pill ok"><span class="pr-dot"></span>Activo</span>` : `<span class="pr-pill na">Inactivo</span>`}
          ${t.usuarioPlataformaId ? `<span class="pr-pill blue" style="margin-left:4px" title="Tiene cuenta de plataforma">✓ Cuenta</span>` : `<span class="pr-pill na" style="margin-left:4px" title="Sin cuenta (técnico legacy)">— Sin cuenta</span>`}
        </td>
        <td>
          <div class="pr-actions">
            <button class="sx-btn sx-btn-secondary sx-btn-sm" data-act="editar" data-idx="${i}">Editar</button>
            <button class="sx-btn sx-btn-ghost sx-btn-icon sx-btn-sm" data-act="eliminar" data-idx="${i}" title="Eliminar"><i class="ph ph-trash"></i></button>
          </div>
        </td>
      </tr>`).join("");

    this._tbody.querySelectorAll<HTMLButtonElement>("button[data-act]").forEach((btn) => {
      const t = list[Number(btn.dataset.idx)];
      btn.onclick = () => {
        if (btn.dataset.act === "editar")   this._onEdit(t);
        if (btn.dataset.act === "eliminar") this._onDelete(t);
      };
    });
  }

  private _onCreate(): void {
    new TecnicoFormModal((saved) => {
      this._all = [saved, ...this._all].sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._filterAndRender();
      void this._loadStats();
      errorMessageComponent.addSuccess("Técnico creado", "Se le envió una invitación por correo con sus credenciales de acceso.");
    }).init();
  }

  private _onEdit(t: TecnicoResponse): void {
    new TecnicoFormModal((saved) => {
      this._all = this._all.map((x) => (x.id === saved.id ? saved : x));
      this._filterAndRender();
      void this._loadStats();
    }, t).init();
  }

  private _onDelete(t: TecnicoResponse): void {
    new ConfirmDialogComponent({
      title: "Eliminar técnico",
      message: `¿Eliminar a "${t.nombre}"?`,
      confirmLabel: "Eliminar",
      onConfirm: async () => {
        try {
          await new TecnicoDeleteService().delete(t.id);
          this._all = this._all.filter((x) => x.id !== t.id);
          this._filterAndRender();
          void this._loadStats();
        } catch (error) {
          errorMessageComponent.addError("Error al eliminar", (error as Error).message);
        }
      },
    }).init();
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
